import { ChainId, Token, WETH } from '@pancakeswap/sdk'

export const MAIN_TOKEN = {
  [ChainId.BSC]: new Token(
    ChainId.BSC,
    '0x8E164777cfc70f5Bb96B3Ee7E96734c0FD1f67F1',
    8,
    'THBM',
    'THAIBAHTMGP',
    'https://lucclub.com/'
  ),

  // [ChainId.ETH]: new Token(
  //   ChainId.ETH,
  //   '0x514910771AF9Ca656af840dff83E8264EcF986CA',
  //   18,
  //   'LINK',
  //   'ChainLink Token',
  //   'https://lucclub.com/'
  // ),
  // [ChainId.ARB]: new Token(
  //   ChainId.ARB,
  //   '0x2c135242795DDD53827a6E9B776959e51078f907',
  //   18,
  //   'FNX',
  //   'Four Nine X Ai',
  //   'https://lucclub.com/'
  // ),
  // [ChainId.BASE]: new Token(
  //   ChainId.BASE,
  //   '0xFE3A9C20Aa8396907F9fb5E9704dC4B9Aefd7FE7',
  //   18,
  //   'FNX',
  //   'Four Nine X Ai',
  //   'https://lucclub.com/'
  // ),
  // [ChainId.POLYGON]: new Token(
  //   ChainId.POLYGON,
  //   '0x916f1024ebDC39887D99eC1C956eC6dC59d68dE0',
  //   18,
  //   'FNX',
  //   'Four Nine X Ai',
  //   'https://lucclub.com/'
  // )

  [ChainId.BSC_TESTNET]: new Token(
    ChainId.BSC_TESTNET,
    '0xd7fC6e8f6fa3Ed26de65C053978a327f599B151c',
    18,
    'DANNY',
    'DAN',
    'https://lucclub.com/'
  ),
  // [ChainId.BASE_SEPOLIA]: new Token(
  //   ChainId.BASE_SEPOLIA,
  //   '0x1F93D2d3dB35AbB69a2e86541aBC959D29dfFd58',
  //   18,
  //   'WAPH',
  //   'WAPH Coin',
  //   'https://lucclub.com/'
  // ),


  // [ChainId.DAN]: new Token(
  //   ChainId.DAN,
  //   '0xD84b7c96c23BAb37b585Bac98DFE6651D30F6c11',
  //   18,
  //   'HMOOB',
  //   'HMOOB COIN',
  //   'https://lucclub.com/'
  // ),
  // [ChainId.DANNY]: new Token(
  //   ChainId.DANNY,
  //   '0x1c2cD5d8f44C2aa37c87676Ac4200c2329AB019d',
  //   18,
  //   'HMOOB',
  //   'HMOOB COIN',
  //   'https://lucclub.com/'
  // ),


}

export const USDT = {
  [ChainId.BSC]: new Token(
    ChainId.BSC,
    '0x55d398326f99059fF775485246999027B3197955',
    18,
    'USDT',
    'USDT',
    'https://www.binance.com/',
  ),

  // [ChainId.ETH]: new Token(
  //   ChainId.ETH,
  //   '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
  //   6,
  //   'USDC',
  //   'USDC',
  //   'https://www.centre.io/usdt'
  // ),
  // [ChainId.ARB]: new Token(
  //   ChainId.ARB,
  //   '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
  //   6,
  //   'USDC',
  //   'USDC',
  //   'https://www.centre.io/usdt'
  // ),
  // [ChainId.BASE]: new Token(
  //   ChainId.BASE,
  //   '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
  //   6,
  //   'USDC',
  //   'USDC',
  //   'https://www.centre.io/usdt'
  // ),
  // [ChainId.POLYGON]: new Token(
  //   ChainId.POLYGON,
  //   '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
  //   6,
  //   'USDT',
  //   'Tether USD',
  //   'https://lucclub.com/'
  // )
  [ChainId.BSC_TESTNET]: new Token(
    ChainId.BSC_TESTNET,
    '0xC28112C2EC55aE1F15b78b51FC101b80eD1d529E',
    18,
    'USDT',
    'Tether USD',
    'https://www.centre.io/usdt'
  ),

  // [ChainId.BASE_SEPOLIA]: new Token(
  //   ChainId.BASE_SEPOLIA,
  //   '0xadC3bA24361b37aA8bE832fF26eCa68edE613d6B',
  //   18,
  //   'USDT',
  //   'Tether USD',
  //   'https://www.centre.io/usdt'
  // ),

  // [ChainId.DAN]: new Token(
  //   ChainId.DAN,
  //   '0x3A07aBE1Abce54838550A1d2aec4CBd961a39084',
  //   18,
  //   'USDT',
  //   'Bridge USDT',
  //   'https://lucclub.com/'
  // ),
  // [ChainId.DANNY]: new Token(
  //   ChainId.DANNY,
  //   '0xb9BFa68B6774612e66eB693C7a0D00B2Eb6BCdee',
  //   8,
  //   'USDT',
  //   'Bridge USDT',
  //   'https://lucclub.com/'
  // ),

}

export const BUSD = {
  [ChainId.BSC]: new Token(
    ChainId.BSC,
    '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
    18,
    'BUSD',
    'BUSD',
    'https://www.binance.com/',
  ),
  [ChainId.BSC_TESTNET]: new Token(
    ChainId.BSC_TESTNET,
    '0xeD24FC36d5Ee211Ea25A80239Fb8C4Cfd80f12Ee',
    18,
    'BUSD',
    'BUSD',
    'https://www.binance.com/',
  ),
  // [ChainId.ARB]: new Token(
  //   ChainId.ARB,
  //   '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
  //   6,
  //   'USDC',
  //   'USD Coin',
  //   'https://www.centre.io/usdt'
  // ),
  // [ChainId.ETH]: new Token(
  //   ChainId.ETH,
  //   '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
  //   6,
  //   'USDC',
  //   'USD Coin',
  //   'https://www.centre.io/usdt'
  // ),
  // [ChainId.BASE]: new Token(
  //   ChainId.BASE,
  //   '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
  //   6,
  //   'USDC',
  //   'USDC',
  //   'https://www.centre.io/usdt'
  // ),
  // [ChainId.BASE_SEPOLIA]: new Token(
  //   ChainId.BASE_SEPOLIA,
  //   '0x1F93D2d3dB35AbB69a2e86541aBC959D29dfFd58',
  //   18,
  //   'WAPH',
  //   'WAPH Coin',
  //   'https://lucclub.com/'
  // ),
  // [ChainId.POLYGON]: new Token(
  //   ChainId.POLYGON,
  //   '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
  //   18,
  //   'USDC',
  //   'USD Coin',
  //   'https://lucclub.com/'
  // )


  // [ChainId.DAN]: new Token(
  //   ChainId.DAN,
  //   '0x3A07aBE1Abce54838550A1d2aec4CBd961a39084',
  //   18,
  //   'USDT',
  //   'Bridge USDT',
  //   'https://lucclub.com/'
  // ),
  // [ChainId.DANNY]: new Token(
  //   ChainId.DANNY,
  //   '0xb9BFa68B6774612e66eB693C7a0D00B2Eb6BCdee',
  //   8,
  //   'USDT',
  //   'Bridge USDT',
  //   'https://lucclub.com/'
  // ),
}

export const WBNB = {
  [ChainId.BSC]: new Token(
    ChainId.BSC,
    '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    18,
    'BNB',
    'BNB',
    'https://www.binance.com/',
  ),
  [ChainId.BSC_TESTNET]: new Token(
    ChainId.BSC_TESTNET,
    '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd',
    18,
    'BNB',
    'BNB',
    'https://www.binance.com/',
  ),
  // [ChainId.ETH]: new Token(
  //   ChainId.ETH,
  //   '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
  //   18,
  //   'ETH',
  //   'ETH',
  //   'https://www.binance.com/',
  // ),
  // [ChainId.ARB]: new Token(
  //   ChainId.ARB,
  //   '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
  //   18,
  //   'ETH',
  //   'ETH',
  //   'https://www.binance.com/',
  // ),
  // [ChainId.BASE]: new Token(
  //   ChainId.BASE,
  //   '0x4200000000000000000000000000000000000006',
  //   18,
  //   'ETH',
  //   'ETH',
  //   'https://www.binance.com/',
  // ),
  // [ChainId.BASE_SEPOLIA]: new Token(
  //   ChainId.BASE_SEPOLIA,
  //   '0x24fe7807089e321395172633aA9c4bBa4Ac4a357',
  //   18,
  //   'ETH',
  //   'ETH',
  //   'https://lucclub.com/'
  // ),
  // [ChainId.POLYGON]: new Token(
  //   ChainId.POLYGON,
  //   '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6',
  //   8,
  //   'WBTC',
  //   'Wrapped BTC',
  //   'https://lucclub.com/'
  // )
  // [ChainId.DAN]: new Token(
  //   ChainId.DAN,
  //   '0xBB37263380d2AD59d7CE807Bb9EFA1A697598e7F',
  //   18,
  //   'WDAN',
  //   'Wrapped DAN',
  //   'https://lucclub.com/'
  // ),
  // [ChainId.DANNY]: new Token(
  //   ChainId.DANNY,
  //   '0xBEe33b6B1C3df2c4468510E87d6330daA5709F3E',
  //   18,
  //   'WDAN',
  //   'Wrapped DAN',
  //   'https://lucclub.com/'
  // ),
}

export const MAIN_TOKEN2 = {
  [ChainId.BSC]: new Token(
    ChainId.BSC,
    '0x8C6252b0Dc9C109D692e21F7f7284fDd69aBC724',
    18,
    'LUC',
    'LUCKYINVEST',
    'https://mms-soilminerals.com/'
  ),
  [ChainId.BSC_TESTNET]: new Token(
    ChainId.BSC_TESTNET,
    '0xcC87f415d4C3f9dA9a2Ba1420da6073953d4035c',
    18,
    'LUC',
    'LUCKYINVEST',
    'https://mms-soilminerals.com/'
  ),
  // [ChainId.ARB]: new Token(
  //   ChainId.ARB,
  //   '0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f',
  //   8,
  //   'WBTC',
  //   'Wrapped BTC',
  //   'https://mms-soilminerals.com/'
  // ),
  // [ChainId.ETH]: new Token(
  //   ChainId.ETH,
  //   '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
  //   8,
  //   'WBTC',
  //   'Wrapped BTC',
  //   'https://mms-soilminerals.com/'
  // ),
  // [ChainId.BASE]: new Token(
  //   ChainId.BASE,
  //   '0x0555E30da8f98308EdB960aa94C0Db47230d2B9c',
  //   8,
  //   'WBTC',
  //   'Wrapped BTC',
  //   'https://mms-soilminerals.com/'
  // ),
  // [ChainId.BASE_SEPOLIA]: new Token(
  //   ChainId.BASE_SEPOLIA,
  //   '0x1F93D2d3dB35AbB69a2e86541aBC959D29dfFd58',
  //   18,
  //   'WAPH',
  //   'WAPH Coin',
  //   'https://lucclub.com/'
  // ),
  // [ChainId.POLYGON]: new Token(
  //   ChainId.POLYGON,
  //   '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
  //   18,
  //   'DAI',
  //   'Dai Stablecoin',
  //   'https://lucclub.com/'
  // )
  // [ChainId.DAN]: new Token(
  //   ChainId.DAN,
  //   '0x82784a1EF9d619BC6A9B66a8eB72926ED4cc1A58',
  //   18,
  //   'UNI',
  //   'UNICORN',
  //   'https://lucclub.com/'
  // ),
  // [ChainId.DANNY]: new Token(
  //   ChainId.DANNY,
  //   '0x31FFA7218D59D4E83673E878875f5215e35e8fdE',
  //   18,
  //   'UNI',
  //   'UNICORN',
  //   'https://lucclub.com/'
  // ),
}

export const MAIN_TOKEN3 = {
  [ChainId.BSC]: new Token(
    ChainId.BSC,
    '0x8Af89e96BB7cABb16AE7545ebda99630F9942059',
    18,
    'ME',
    'MEME',
    'https://mms-soilminerals.com/'
  ),
  [ChainId.BSC_TESTNET]: new Token(
    ChainId.BSC_TESTNET,
    '0x7B3E14386463A18aA9Ca8Ea3dAF534313F3695EE',
    18,
    'MALI',
    'MALIRICE',
    'https://mms-soilminerals.com/'
  ),
  // [ChainId.ARB]: new Token(
  //   ChainId.ARB,
  //   '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
  //   18,
  //   'USDe',
  //   'USDe',
  //   'https://mms-soilminerals.com/'
  // ),
  // [ChainId.ETH]: new Token(
  //   ChainId.ETH,
  //   '0xdAC17F958D2ee523a2206206994597C13D831ec7',
  //   6,
  //   'USDT',
  //   'Tether USD',
  //   'https://mms-soilminerals.com/'
  // ),
  // [ChainId.BASE]: new Token(
  //   ChainId.BASE,
  //   '0x8d010bf9C26881788b4e6bf5Fd1bdC358c8F90b8',
  //   18,
  //   'DOT',
  //   'Polkadot Token',
  //   'https://mms-soilminerals.com/'
  // ),
  // [ChainId.BASE_SEPOLIA]: new Token(
  //   ChainId.BASE_SEPOLIA,
  //   '0x1F93D2d3dB35AbB69a2e86541aBC959D29dfFd58',
  //   18,
  //   'WAPH',
  //   'WAPH Coin',
  //   'https://lucclub.com/'
  // ),
  // [ChainId.POLYGON]: new Token(
  //   ChainId.POLYGON,
  //   '0x2C89bbc92BD86F8075d1DEcc58C7F4E0107f286b',
  //   18,
  //   'AVAX',
  //   'Avalanche Token',
  //   'https://lucclub.com/'
  // )
  // [ChainId.DAN]: new Token(
  //   ChainId.DAN,
  //   '0xA7eC88a4ca504f003f1337482Eb72904C1da883A',
  //   18,
  //   'DS',
  //   'DAISY',
  //   'https://lucclub.com/'
  // ),
  // [ChainId.DANNY]: new Token(
  //   ChainId.DANNY,
  //   '0xC7a34fCeD3d2aC8F1C09C41D00221DC35CDF70Dc',
  //   18,
  //   'DS',
  //   'DAISY',
  //   'https://lucclub.com/'
  // ),
}

export const MAIN_TOKEN4 = {
  [ChainId.BSC]: new Token(
    ChainId.BSC,
    '0xf5a82367823Cd69089C5e51a7298bF0Bb739546A',
    8,
    'BIGMCASH',
    'BIGMCASH',
    'https://mms-soilminerals.com/'
  ),
  [ChainId.BSC_TESTNET]: new Token(
    ChainId.BSC_TESTNET,
    '0xFF0E9946D0b596835C2Acc41eb7FDef30579D6fF',
    18,
    'BKR',
    'BKR',
    'https://mms-soilminerals.com/'
  ),
  // [ChainId.ARB]: new Token(
  //   ChainId.ARB,
  //   '0x912CE59144191C1204E64559FE8253a0e49E6548',
  //   18,
  //   'ARB',
  //   'Arbitrum',
  //   'https://mms-soilminerals.com/'
  // ),
  // [ChainId.ETH]: new Token(
  //   ChainId.ETH,
  //   '0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE',
  //   18,
  //   'SHIB',
  //   'SHIBA INU',
  //   'https://mms-soilminerals.com/'
  // ),
  // [ChainId.BASE]: new Token(
  //   ChainId.BASE,
  //   '0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb',
  //   18,
  //   'DAI',
  //   'Dai Stablecoin',
  //   'https://mms-soilminerals.com/'
  // ),
  // [ChainId.BASE_SEPOLIA]: new Token(
  //   ChainId.BASE_SEPOLIA,
  //   '0x1F93D2d3dB35AbB69a2e86541aBC959D29dfFd58',
  //   18,
  //   'WAPH',
  //   'WAPH Coin',
  //   'https://lucclub.com/'
  // ),
  // [ChainId.POLYGON]: new Token(
  //   ChainId.POLYGON,
  //   '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
  //   6,
  //   'USDC',
  //   'USDC',
  //   'https://lucclub.com/'
  // )

  // [ChainId.DAN]: new Token(
  //   ChainId.DAN,
  //   '0xC94A9eDb5F27D9379A783Ea68831F67FCe7F9475',
  //   18,
  //   'FZ',
  //   'FASTZY',
  //   'https://lucclub.com/'
  // ),
  // [ChainId.DANNY]: new Token(
  //   ChainId.DANNY,
  //   '0x28965Df36b63a8055faD24B43cdb4eA7d0A31C60',
  //   18,
  //   'FZ',
  //   'FASTZY',
  //   'https://lucclub.com/'
  // ),
}

export const SWAP = {
  [ChainId.BSC]: MAIN_TOKEN[ChainId.BSC],
  [ChainId.BSC_TESTNET]: MAIN_TOKEN[ChainId.BSC_TESTNET],
  // [ChainId.ETH]: MAIN_TOKEN[ChainId.ETH],
  // [ChainId.ARB]: MAIN_TOKEN[ChainId.ARB],
  // [ChainId.BASE]: MAIN_TOKEN[ChainId.BASE],
  // [ChainId.BASE_SEPOLIA]: MAIN_TOKEN[ChainId.BASE_SEPOLIA],
  // [ChainId.POLYGON]: MAIN_TOKEN[ChainId.POLYGON],
  // [ChainId.DAN]: MAIN_TOKEN[ChainId.DAN],
  // [ChainId.DANNY]: MAIN_TOKEN[ChainId.DANNY],
}

export const SWAP2 = {
  [ChainId.BSC]: USDT[ChainId.BSC],
  [ChainId.BSC_TESTNET]: USDT[ChainId.BSC_TESTNET],
  // [ChainId.ETH]: USDT[ChainId.ETH],
  // [ChainId.ARB]: USDT[ChainId.ARB],
  // [ChainId.BASE]: USDT[ChainId.BASE],
  // [ChainId.BASE_SEPOLIA]: USDT[ChainId.BASE_SEPOLIA],
  // [ChainId.POLYGON]: USDT[ChainId.POLYGON],
  // [ChainId.DAN]: USDT[ChainId.DAN],
  // [ChainId.DANNY]: USDT[ChainId.DANNY],
}



export const bscTokens = {
  wbnb: WETH[ChainId.BSC],
  bnb: WBNB[ChainId.BSC],
  busd: BUSD[ChainId.BSC],
  usdt: USDT[ChainId.BSC],
  bkr: MAIN_TOKEN2[ChainId.BSC],
  cake: MAIN_TOKEN[ChainId.BSC],
  mali: MAIN_TOKEN3[ChainId.BSC],
  cbn: MAIN_TOKEN4[ChainId.BSC]
}


export const USDW = {
  [ChainId.BSC]: new Token(
    ChainId.BSC,
    '0x8E164777cfc70f5Bb96B3Ee7E96734c0FD1f67F1',
    18,
    'THBM',
    'THAIBAHTMGP',
    'https://mms-soilminerals.com/'
  ),
  [ChainId.BSC_TESTNET]: new Token(
    ChainId.BSC_TESTNET,
    '0xF32FAc0343D8ac179eB9188a3cb7650A5a480715',
    18,
    'THBM',
    'THBM',
    'https://mms-soilminerals.com/'
  ),
}

export const CUSTOM_STABLE_COINS = [USDW]
